module.exports = __webpack_public_path__ + "static/media/slack.2a75872f.svg";